import { unitRegistry } from './shared/instance';

/**
 * Catalog units label for a unit key, without formatUnits vacuum routing.
 * Use while the operator is typing values that are in displayUnits.
 */
export function getCatalogUnitsLabel(units?: string): string {
  if (!units) return '';
  const formatter = unitRegistry.formatters[units.toLowerCase()];
  if (!formatter) return '';
  // Precision formatters ignore value for the label; 0 → PSIG for formatPsigInhg.
  return formatter({ value: 0 }).unitsLabel;
}
